import GraphQLClient from 'services/apollo/GraphQLClient';
import VehicleQuery from 'services/graphQL/query/VehicleQuery';
import CatalogQuery from 'services/graphQL/query/CatalogQuery';
import { InventoryColor } from 'utils/enum/InventoryEnum';

export default class VehicleService {
    constructor() {
        this.graphqlClient = new GraphQLClient();
    }

    /**
     * Decode a Vin and returns the vehicle data
     * @param {string} vin
     * @returns {Promise<Object>}
     */
    async decodeVIN(vin) {
        return this.graphqlClient.query(VehicleQuery.DECODE_VIN, { vin });
    }

    async getColorsFromCatalog() {
        return this.graphqlClient.query(CatalogQuery.ENUM_VALUES, { descriptions: [InventoryColor.EXTERIOR_COLOR] });
    }
}
